<template>
  <!--Footer-->
  <footer id="contact" class = "p-5 pt-4 bg-light text-light" style="z-index:100; background: url('image/blackboard.jpg') top center fixed; background-size: cover;  ">
    <div class = "row">
      <div class = "col-6 col-md-3 mt-4 mb-3">
        <p class = "h6 fw-bold mb-3">دوره ها</p>

        <a href = "/" class = "d-block text-light">حضوری</a>
        <a href = "/" class = "d-block text-light">آنلاین</a>
        <a href = "/" class = "d-block text-light">ویدئوی</a>
        <a href = "/" class = "d-block text-light">کتاب</a>
      </div>
      <div class = "col-6 col-md-3 mt-4 mb-3">
        <p class = "h6 fw-bold mb-3">حساب کاربری</p>

        <a href = "/" class = "d-block text-light">پروفایل من</a>
        <a href = "/" class = "d-block text-light">دوره های من</a>
        <a href = "/" class = "d-block text-light">استاد ها</a>
        <a href = "/" class = "d-block text-light">خروج</a>
      </div>
      <div class = "col-12 col-md-6 mt-4 mb-3">
        <p class = "h6 fw-bold mb-3">
          تماس با ما</p>
        <p class = "">نشانی: تهران شیان خیابان شهید فرشادی نبش کوچه خندان پلاک ۵ ساختمان
          آراتل طبقه دوم</p>
        <p class = "">ایمیل: webagent.ir@gmail.com</p>
        <p class = "">تلفن:
          <a class = "text-light" href = "tel:09032313681" dir = "ltr">09032313681</a></p>

        <div class = "social-links mt-3 d-flex justify-content-end">
          <span class = "span"><a style="font-size: 12px" class = "" href = "tel:09032313681"><i class = "fas fa-phone text-light mx-auto"></i></a></span>
          <span class = "span"><a target = "_blank" href = "https://api.whatsapp.com/send?phone=989032313681"><i class = "fab fa-whatsapp mx-auto text-light mx-2"></i></a></span>
          <span class = "span"><a target = "_blank" href = "https://t.me/webagent_ir"><i class = "fab fa-telegram  mx-auto text-light mx-2"></i></a></span>
          <span class = "span"><a target = "_blank" href = "https://www.instagram.com/webagent.ir"><i class = "fab fa-instagram   mx-auto text-light mx-2"></i></a></span>
          <span class = "span"><a target = "_blank" href = "https://linkedin.com/in/roxanarahimi"><i class = "fab fa-linkedin  mx-auto text-light mx-2"></i></a></span>

        </div>
      </div>
      <hr>
      <small> © رکسانا رحیمی 1397 </small></div>
  </footer>
  <!--End Footer-->
</template>

<script>
export default {
  name: "TheFooter"
}
</script>

<style scoped>

</style>